export default __webpack_public_path__ + "media/25d4185cc7df2a485146e9edf8ab71c343f462b2d715a8d16669c45455db7d81.svg";